<template>
  <div class="col mt-6">
    <h6 class="header-pretitle">
      {{ schoolInfo }}
    </h6>
    <h1 class="header-title">
      {{ studentName }}
    </h1>
    <p class="text-muted" v-if="route == 'Home'">
      <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekrandan Evde Sınav ve Sınav Rapor'larına ulaşabilirsin.
    </p>
    <p class="text-muted" v-if="route == 'IncompleteCompletion'">
      <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekrandan girdiğin sınavları ve sınavların sonucuna göre tamamlaman gereken dersleri görebilirsin. 
      <ul>
        <li><span class="badge badge-soft-danger">Kırmızı</span> olan dersler eksiği bulunan ve tamamlaman gerekenlerdir.</li>
        <li><span class="badge badge-soft-primary">Mavi</span> olanlar eksiğini giderdiğin derslerdir.</li>
        <li><span class="badge badge-soft-success">Yeşil</span> olanlar ise zaten başarılı olduğun derslerdir.</li>
      </ul>
    </p>
    <p class="text-muted" v-if="route == 'IncompleteCompletionDetail'">
      <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekrandan seçtiğin sınavda başarısız olduğun konuları görebilirsin. 
      <span class="badge badge-primary">Konu anlatım</span> ve 
      <span class="badge badge-success">soru çözüm</span> videolarını izleyip 
      <span class="badge badge-light">küçük sınavı</span> tamamlayarak eksiğini giderebilirsin.
      <br />
      Yanlış olan her sorunun sağında yer alan butonların başında (<i class="fe fe-x-circle text-dark"></i>) simgesi var ise tamamlanmadı, (<i class="fe fe-check-circle text-dark"></i>) simgesi var ise de tamamlandı anlamına gelmektedir.
    </p>
    <p class="text-muted" v-if="route == 'SmallQuiz'">
      <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekranda öğrendiklerini pekiştirmen için toplam 3 sorudan oluşan küçük bir sınav bulunuyor. 
      Sınavı tamamladığında <span class="badge badge-primary">sınavı bitir</span> butonuna basman yeterli. 
      Ayrıca her sorunun yanında bulunan boş alanı çözüme ulaşırken kullanabilirsin. 
    </p>
    <p class="text-muted" v-if="route == 'Report'">
      <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekrandan detaylı bilgilerle raporunu görüntüleyebilirsin. 
    </p>
    <p class="text-muted" v-if="route == 'HomeWork'">
      <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekranda senin için oluşturulan sınavlar listelenmektedir. Sınav için belirlenen süre (tarih-saat) dolmamışsa sınava girebilirsin. Sınav süresi dolan sınavlara tıklayarak ise sınav sonucunu görebilirsin. Ayrıca bazı ön bilgiler vermek istiyoruz. Bunları şu şekilde sıralayalım;
      <ul>
        <li>Öncelikle “Evde Sınav” için en uygun cihaz Windows işletim sistemine sahip bir bilgisayar ve <a href="https://www.google.com.tr/intl/tr/chrome/" target="_blank">Google Chrome</a> internet tarayıcısıdır. Sorunsuz bir online sınav deneyimi için mümkünse bu cihaz ve tarayıcıyı tercih etmeni öneriyoruz.</li>
        <li>Sınavdan önce mutlaka bilgisayarının saatini kontrol etmelisin. Bilgisayar saatin hatalıysa mutlaka düzeltmelisin.</li>
        <li>Sınav başlama süresi geldiğinde sınavın aktif olması için sayfa yenilemesi yapabilirsin.</li>
        <li>Sınavı verilen bitiş süresinden önce tamamlamalısın.</li>
        <li>Sınava ilk başladığında sınav süren de başlar. Sağ üstte kalan süreni dakika ve saniye olarak görebilirsin ve bu süre içerisinde sınavını tamamlamalısın.</li>
        <li>Soru numaraları üstteki şeritte yer almaktadır. Buradan istediğin soru numarasına tıklayarak doğrudan soruya geçiş yapabilirsin.</li>
        <li>Soruların çözümü için ekranını kullanabilirsin.</li>
        <li>Bir soru için bir cevap şıkkını işaretledikten sonra vazgeçmek istiyorsan cevap şıklarının altında yer alan “Bu soruyu boş bırak” ifadesini tıklayarak seçimini kaldırabilirsin.</li>
        <li>Herhangi bir nedenle sınav sayfasından çıkmışsan tekrar bağlandığında sınav başlama saatine göre kalan süren varsa sınavına devam edebilirsin.</li>
        <li>Tüm soruları cevaplandırdıktan sonra istersen sınav süresinin sonuna kadar bekleyebilir, istersen “Sınavdan Çık” ifadesini tıklayarak çıkış yapabilirsin.</li>
        <li>Sınav süresi dolduğu anda sınav sonuçları aynı ekranda görebilirsin.</li>
        <li>Evde sınav senin gelişimin için hazırlanmıştır. Lütfen okuldaymış gibi sadece sınavla ilgilen. Başarılar dileriz.</li>
      </ul>
    </p>
    <p class="text-muted" v-if="route == 'HomeWorkDetail'">
      <span v-if="this.exam_status == true">
        <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekrandan sınavına giriş sağlayabilirsin. <strong>Başla</strong> butonuna bastığında {{ this.minute }} dakikalık süren başlar.
        <br />
        Başarılar diliyoruz...
      </span>
      <span v-else-if="this.exam_status == null">
        <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, sınavın başladı. Soruları düzgün okuyarak cevaptan emin olunca yanıtlamanda ve emin olmadığın soruları boş bırakmanda fayda var. <br />
        Boş bırakmak istediğin soruda bir cevap işaretlediysen, işaretlediğin cevaba tekrar tıklayarak cevabı kaldırabilirsin.
      </span>
      <span v-else-if="this.exam_status == 'Print'">
        <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, bu ekrandan sınavını yazdırabilirsin. Tüm soruları ve genel istatistiği tek seferde görüntüleyip çıktı alman için hazırlandı.
      </span>
      <span v-else>
        <i class="fe fe-help-circle"></i> Merhaba {{ studentOnlyName }}, sınavın bitti. <strong>Sınav Sonuçları</strong> ekranından sınavla ilgili durumunu görebilirsin.
        <br />
        Ayrıca sorular arasında geçiş yaparak doğru ve yanlış cevapları kontrol edebilirsin.
      </span>
    </p>
  </div>
</template>
<script>
import base from '@/mixins/base';
export default {
  name: 'Head',
  mixins: [ base ],
  props: {
    route: { type: String, required: true, default: 'Home' },
    exam_status: { type: [Boolean, String], required: false, default: false },
    minute: { type: String, required: false, default: '40' }
  },
  data() {
    return {
      student: this.$store.state.auth.student,
      type: this.route,
      time_alert: '',
      device_time: '',
      real_time: '',
      redirect_check: 0
    }
  },
  computed: {
    studentName() {
      if (this.student.AD !== undefined && this.student.SOYAD !== undefined) {
        return this.student.AD + ' ' + this.student.SOYAD
      } else {
        return '';
      }
    },
    studentOnlyName() {
      if (this.student.AD !== undefined) {
        return this.student.AD
      } else {
        return '';
      }
    },
    schoolInfo() {
      if (this.student.OKUL !== undefined && this.student.SINIF !== undefined && this.student.SUBE !== undefined) {
        return this.student.OKUL + ' - ' + this.student.SINIF + '/' + this.student.SUBE
      } else {
        return '';
      }
    }
  },
  created() {
    
  }
}
</script>